import {
    ActivityIndicator,
    ActivityIndicatorProps,
    StyleProp,
    StyleSheet,
    View,
    ViewStyle,
} from "react-native";
import React from "react";

type LoadingProps = {
    color?: string;
    style?: StyleProp<ViewStyle>;
} & Pick<ActivityIndicatorProps, "size">;

const Loading = ({ color, style, size = "large" }: LoadingProps) => {
    return (
        <View style={[styles.container, style]}>
            <ActivityIndicator color={color} size={size} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        justifyContent: "center",
    },
});

export default Loading;
